{
	"id": 7819576,
	"numericId": 7819576,
	"collectionId": 786,
	"status": "ACTIVE",
	"sessionTime": 0,
	"startTime": "2026-05-20T06:08:40.381Z",
	"examBreak": null,
	"timeAllocation": null,
	"progressList": [],
	"sessionItems": [
		{
			"id": 103679,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"overview": {
					"title": "The Professional Educator and the School",
					"summary": "This module contains two activities and a five-question end-of-module knowledge check. It will take approximately 30 to 40 minutes to complete the entire module.",
					"moduleNumber": 4,
					"activityCount": 2,
					"knowledgeCheckCount": 5,
					"estimatedDurationMinutes": 35
				},
				"moduleOutline": {
					"heading": "Module Outline",
					"sections": [
						{
							"items": [
								{
									"icon": "circle-play",
									"title": "Video"
								},
								{
									"icon": "messages-square",
									"title": "Perspectives"
								},
								{
									"icon": "square-pen",
									"title": "Reflect"
								},
								{
									"icon": "compass",
									"title": "Explore"
								},
								{
									"icon": "clipboard-check",
									"title": "Review"
								},
								{
									"icon": "chart-column-increasing",
									"title": "Analysis"
								}
							],
							"title": "Scenario: Mr. Bolden"
						},
						{
							"title": "Ethical Situations: Take Action or Let it Go"
						},
						{
							"title": "Module 4 Summary"
						}
					]
				},
				"learningObjectives": {
					"heading": "Learning Objectives",
					"objectives": [
						"Analyzing a scenario to differentiate how dispositional and regulatory frameworks influence decision making and determining an appropriate course of action",
						"Evaluating competing tensions to select actions aligned with ethical principles",
						"Applying decision criteria aligned to the *Model Code of Ethics for Educators* (*MCEE*) to resolve ethical scenarios"
					]
				}
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "module_intro",
				"language": "en-US",
				"position": 1,
				"sourceId": 4010
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37090,
					"label": "Module 4: The Professional Educator and the School",
					"title": "Module 4: The Professional Educator and the School",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103680,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will consider a scenario involving a teacher and a paraeducator.\n\nFirst, you will review a video that shows the interactions between a new paraeducator, her colleague, and their students. Then, you will gain further insight by reviewing a video showing the perspectives of the paraeducator and another educator involved in the scenario. After observing the videos, you will reflect on and explore the ethical dilemmas depicted in the scenario.",
				"media": [
					{
						"type": "VIDEO",
						"title": "Mr. Bolden",
						"videoUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-4/m4_scenario.mp4",
						"transcript": "**Mr. Bolden’s 5th Grade Math Class: Mr. Bolden and Ms. Gonzalez**\n\nThe video shows a series of classroom scenes in which Mr. Bolden and Ms. Gonzalez interact with each other and with their students.\n\n**Scene 1**\n\nMr. Bolden: Alright, class, pay attention. Today we’re multiplying fractions. We don’t have time for confusion. We’ve practiced this.\n\nMs. Gonzalez: Joey, let’s review your fraction strips together. We’ll take it one step at a time.\n\nJoey: I’m not sure how to start this one.\n\nMr. Bolden: You should know this by now. We’ve covered this for days. Keep trying until you get it.\n\nMs. Gonzalez: Joey, let’s rewrite the fractions and multiply across. You’ve got this.\n\n**Scene 2**\n\nMs. Gonzalez: Several students seem unsure. Want me to pull a small group to the back?\n\nMr. Bolden: No. They need to toughen up. Leave them at their desks. They’ll figure it out.\n\nMs. Gonzalez: Alright. I’ll keep supporting from here.\n\n**Scene 3**\n\nMs. Gonzalez: Rina, it’s okay to feel stuck. Let’s breathe and work through one problem together.\n\nMr. Bolden: Rina, we don’t put our heads down in this room. Sit up and focus. Ms. Gonzalez, they rely on you too much.\n\nMs. Gonzalez: I’ll continue to support as needed.\n\n**Scene 4**\n\nMs. Gonzalez: Some students might benefit from visual aids. Should I pass out the fraction tiles?\n\nMr. Bolden: No. If we keep giving them supports, they’ll never learn independence.\n\nMs. Gonzalez: Okay. I’ll check in individually.\n\n**Scene 5**\n\nMs. Gonzalez: Mr. Bolden, this student looks overwhelmed. May I take him for a quick regulation break?\n\nMr. Bolden: No. We’re staying on task.\n\nMs. Gonzalez: Alright. I’ll support him here.\n\n**Scene 6**\n\nMr. Bolden: If students stopped relying on extra help, they’d finally learn the material. We’re moving too slowly because of all the assistance happening.\n\nMs. Gonzalez: I’m here to support learning, and the students are making progress.\n\n**Scene 7: Ms. Gonzalez reflects on her interactions with Mr. Bolden.**\n\nMs. Gonzalez: This isn’t just a disagreement. It’s about ensuring ethical practices. I need to review our school procedures and the Model Code of Ethics for Educators to find the best next steps.",
						"transcriptTitle": "Transcript for Mr. Bolden video",
						"transcriptInstruction": "**Directions:** Select the following expandable text button to access the transcript of the video."
					}
				],
				"title": "Scenario: Mr. Bolden",
				"instruction": "**Directions:** Review the following video to learn about the scenario. Select the play button to begin. Use the video controls when needed."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_presentation",
				"language": "en-US",
				"position": 2,
				"sourceId": 4020
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37090,
					"label": "Module 4: The Professional Educator and the School",
					"title": "Module 4: The Professional Educator and the School",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103681,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of thirteen situations that require you to decide if an educator should “Take action” or “Let it go.” After each situation, you will be presented with two flip cards that describe possible outcomes. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: Take Action or Let It Go",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Good job. Educators should not consume or possess alcohol at any school-related function. Politely decline the alcoholic beverage. Maintain professional boundaries at all school‑related events, including fundraisers. Educators model professionalism. Public behavior affects credibility and trust."
							},
							"label": "Take action"
						},
						{
							"id": "B",
							"back": {
								"text": "Try again. Accepting alcohol at a school event can blur professional boundaries and damage the trust that students and families have with you."
							},
							"label": "Let it go"
						}
					],
					"count": 13,
					"setup": "You are attending a summer fundraiser for your school’s PTO with students, parents, and other teachers. Someone offers you an alcoholic beverage.",
					"title": "Situation 2: School Events",
					"number": 2,
					"prompt": "What should you do?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following two flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 9,
				"sourceId": 4090
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37090,
					"label": "Module 4: The Professional Educator and the School",
					"title": "Module 4: The Professional Educator and the School",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103682,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "The first step in navigating ethical dilemmas is to understand how your values and dispositions can affect your decisions. Educators’ decisions are influenced by two frameworks: dispositional and regulatory. The influence of each framework varies, and educators can be influenced more strongly by one framework than by another. Reflect on what influenced Ms. Gonzalez’ decisions regarding Mr. Bolden.",
				"title": "Scenario: Reflect",
				"question": "Was Ms. Gonzalez influenced more by her dispositional framework or the regulatory framework?",
				"instruction": "**Directions:** Select each of the following two frameworks to read its definition. Then answer the question by choosing one of the frameworks and selecting Submit. If needed, you can try again and select the alternative framework to reveal the explanation."
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "scenario_reflect_framework_choice",
				"language": "en-US",
				"position": 4,
				"sourceId": 4040
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "3016e112-f458-40b4-8d31-e8e2fc01ebe6",
						"isCorrect": true
					},
					{
						"choiceId": "77af3251-1158-4436-9213-4667779e7541",
						"isCorrect": true
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "3016e112-f458-40b4-8d31-e8e2fc01ebe6",
					"detailed": {
						"text": "Good job. One perspective is that Ms. Gonzalez was influenced more by her dispositional framework because her initial reactions are influenced by her personal and professional values, particularly her beliefs in treating students with dignity and fostering supportive, respectful relationships. Even before she fully considered policy or formal expectations, her internal sense of right and wrong signaled that Mr. Bolden’s behavior was inconsistent with ethical guidelines. Her discomfort arose from her instincts as an educator committed to student well-being. These values guided her initial thinking, prompting her to question what she witnessed even though the school culture seemed to normalize it. Select the other choice to see how Ms. Gonzalez was influenced by the regulatory framework."
					},
					"language": "en-US"
				},
				{
					"type": "STATIC",
					"choiceId": "77af3251-1158-4436-9213-4667779e7541",
					"detailed": {
						"text": "Good job. One perspective is that Ms. Gonzalez was influenced more by the regulatory framework because her concerns became clearer once she reflected on the formal expectations outlined in school policy and the *Model Code of Ethics for Educators* (*MCEE*). As she considered her professional obligations, such as ensuring student safety, maintaining objectivity, and upholding the integrity of the profession, her decisions increasingly aligned with regulatory guidance rather than personal values alone. The structure provided by ethical standards and district procedures clarified that her observations were not simply a matter of personal discomfort but instead reflected legitimate professional concerns requiring appropriate action. Select the other choice to see how Ms. Gonzalez was influenced by her dispositional framework."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "3016e112-f458-40b4-8d31-e8e2fc01ebe6",
						"icon": "heart-handshake",
						"text": "Influenced More by Dispositional Framework",
						"description": "The personal and professional attitudes, values, and beliefs that inform a professional educator’s decision making.",
						"numFirstSelections": 0
					},
					{
						"id": "77af3251-1158-4436-9213-4667779e7541",
						"icon": "scale",
						"text": "Influenced More by Regulatory Framework",
						"description": "School or district policies, state statutes, and criminal laws that form the basis for conduct absolutes and inform a professional educator’s decision making.",
						"numFirstSelections": 0
					}
				],
				"shuffle": false
			},
			"tags": [
				{
					"id": 37090,
					"label": "Module 4: The Professional Educator and the School",
					"title": "Module 4: The Professional Educator and the School",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103683,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "Gain further insight by reviewing the following video showing the perspectives of people involved in the scenario.",
				"items": [
					{
						"media": {
							"type": "VIDEO",
							"videoUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-4/m4_perspective_teacher_workroom.mp4",
							"transcript": "**Teacher Workroom: Ms. Gonzalez and Ms. Chen**\n\nThe video shows a paraeducator, Ms. Gonzalez, talking to Ms. Chen, a teacher, in a teacher workroom. Ms. Chen is already sitting at a table when Ms. Gonzalez takes a seat across from her.\n\nMs. Chen: Hey, you made it. Everything okay? You look worn out.\n\nMs. Gonzalez: It was another challenging day in Mr. Bolden’s room. I’m trying to stay focused on the students. But the way he interacts with both them and with me is upsetting.\n\nMs. Chen: What happened today?\n\nMs. Gonzalez: He shut down every support I tried to offer. Even when a student was clearly overwhelmed, Mr. Bolden refused a short break. And he criticized my approach in front of the whole class again.\n\nMs. Chen: How does that make you feel?\n\nMs. Gonzalez: A few colleagues say, “that’s just how he teaches.” But it doesn’t feel right to me. It goes against everything we were taught and everything in the Model Code of Ethics for Educators. I’m struggling with what to do next. I don’t want others to think I am “the paraeducator who complains.”\n\nMs. Chen: You’re not overreacting. You’re noticing conflicts between the guidelines in the Model Code of Ethics for Educators and what’s happening in that room. That’s exactly what we’re supposed to identify. You’re not exaggerating. You’re grounding your concerns in professional ethics, not opinions.\n\nMs. Gonzalez: So the next step is documenting what I’ve seen, reviewing our policies, and bringing it to administration.\n\nMs. Chen: Yes. And you approach it respectfully, honestly, and professionally, just like you’ve been doing. You’re advancing the profession and supporting students by raising concerns through the right channels.\n\nMs. Gonzalez [looks relieved]: Thank you. I needed this. It helps to know I’m not alone.\n\nMs. Chen: You’re never alone. You’re doing the right thing for yourself, for your students, and for our profession.",
							"transcriptTitle": "Transcript for Teacher Workroom",
							"transcriptInstruction": "**Directions:** Select the following expandable text button to access the transcript of the video."
						},
						"title": "Teacher Workroom"
					}
				],
				"title": "Scenario: Perspectives",
				"instruction": "**Directions:** Review the following video to learn about the perspectives of Ms. Gonzalez and Ms. Chen. Select the play button to begin. Use the video controls when needed."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_perspective_resource_set",
				"language": "en-US",
				"position": 3,
				"sourceId": 4030
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37090,
					"label": "Module 4: The Professional Educator and the School",
					"title": "Module 4: The Professional Educator and the School",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103684,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of thirteen situations that require you to decide if an educator should “Take action” or “Let it go.” After each situation, you will be presented with two flip cards that describe possible outcomes. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: Take Action or Let It Go",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Good job. Ensure the child’s immediate safety and report the incident according to district policy and state law. Document what you observed. Protecting students from harm is a core ethical responsibility for educators."
							},
							"label": "Take action"
						},
						{
							"id": "B",
							"back": {
								"text": "Try again. Failing to report suspected abuse can keep a child in continued danger and violates ethical and legal duties."
							},
							"label": "Let it go"
						}
					],
					"count": 13,
					"setup": "During a parent-teacher conference, James thinks his daughter, Elysia, is lying and strikes her across the face, causing her nose to bleed.",
					"title": "Situation 3: Parent-Child Altercation",
					"number": 3,
					"prompt": "What should you do?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following two flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 10,
				"sourceId": 4100
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37090,
					"label": "Module 4: The Professional Educator and the School",
					"title": "Module 4: The Professional Educator and the School",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103685,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "Review the ethical principles to determine whether each ethical principle was at immediate risk for Mr. Bolden.",
				"items": [
					{
						"back": {
							"selected": false,
							"riskLevel": "Not At Immediate Risk",
							"explanation": ""
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-01-promoting-solution-discovery-illustration-v2.png"
								}
							],
							"title": "Promoting Solution Discovery"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "Not At Immediate Risk",
							"explanation": ""
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-02-risk-mitigation-illustration-v2.png"
								}
							],
							"title": "Risk Mitigation"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Mr. Bolden interprets the students’ struggles as a lack of effort. He frames support as dependency rather than differentiation. Objectivity requires evaluating student needs without bias."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-03-objectivity-neutrality-maintained-illustration-v3.png"
								}
							],
							"title": "Objectivity and Neutrality Are Maintained"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Requests for accommodations, regulation breaks, and instructional supports are explicitly denied by Mr. Bolden. He treats students’ emotional states as discipline problems rather than learning needs. The educator’s responsibility extends beyond content delivery to emotional, psychological, and intellectual safety."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-04-ensuring-student-welfare-illustration-v2.png"
								}
							],
							"title": "Ensuring Student Welfare"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "Not At Immediate Risk",
							"explanation": ""
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-05-transparency-actions-communications-illustration-v2.png"
								}
							],
							"title": "Transparency in Actions and Communications"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "Not At Immediate Risk",
							"explanation": ""
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-06-boundaries-role-time-place-illustration-v2.png"
								}
							],
							"title": "Honoring the Boundaries of Role, Time, and Place"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Mr. Bolden publicly undermines a colleague in front of students, frames student supports as weaknesses, and reinforces a classroom culture where authority overrides ethical reflection. This places the profession’s credibility at risk within the classroom community."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-07-integrity-profession-illustration-v2.png"
								}
							],
							"title": "Integrity of the Profession Is Promoted by the Educator"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Mr. Bolden’s instructional decisions are grounded in his personal philosophy (for example, he thinks students need to “toughen up”) rather than ethical or regulatory guidance. The *MCEE* exists to prevent individual belief systems from overriding shared personal responsibility."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-08-code-ethics-fidelity-illustration-v2.png"
								}
							],
							"title": "Code of Ethics for Educators Is Maintained with Fidelity"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Mr. Bolden’s refusal to consider accommodations may demonstrate conflict or noncompliance with school policies, special education obligations, and district instructional guidelines."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-09-stewardship-law-public-trust-illustration-v2.png"
								}
							],
							"title": "Stewardship of the Law and Public Trust"
						}
					}
				],
				"title": "Scenario: Review",
				"instruction": "**Directions:** Select each of the following nine flip cards to explore whether each ethical principle was at immediate risk for Mr. Bolden. Each of the nine cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_principle_review_cards",
				"language": "en-US",
				"position": 6,
				"sourceId": 4060
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37090,
					"label": "Module 4: The Professional Educator and the School",
					"title": "Module 4: The Professional Educator and the School",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103686,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of thirteen situations that require you to decide if an educator should “Take action” or “Let it go.” After each situation, you will be presented with two flip cards that describe possible outcomes. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: Take Action or Let It Go",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Good job. Act immediately and stop the student to ensure student safety. School rules apply during all school‑sponsored activities. Follow trip procedures and report the incident as required. Educators are responsible for student safety wherever school activities occur, not just in the classroom."
							},
							"label": "Take action"
						},
						{
							"id": "B",
							"back": {
								"text": "Try again. Ignoring unsafe student behavior because it happens off the school’s property puts students at risk and violates professional responsibility."
							},
							"label": "Let it go"
						}
					],
					"count": 13,
					"setup": "During a school-sponsored, overnight field trip with over 30 students, you catch Damon, a student, attempting to climb in the window of his girlfriend’s hotel room.",
					"title": "Situation 1: What Is Considered School?",
					"number": 1,
					"prompt": "What should you do?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following two flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 8,
				"sourceId": 4080
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37090,
					"label": "Module 4: The Professional Educator and the School",
					"title": "Module 4: The Professional Educator and the School",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103687,
			"versionId": 1,
			"blockId": null,
			"type": "SATA",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "The second step in navigating ethical dilemmas is exploring the risks to the ethical principles.",
				"title": "Scenario: Explore",
				"question": "Which of the following ethical principles were at immediate risk for Mr. Bolden? Select all that apply.",
				"instruction": "**Directions:** Select each of the following nine expandable text buttons to review information about each principle of ethical decision making.",
				"ethicalPrinciples": {
					"items": [
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-01-promoting-solution-discovery-illustration-v2.png"
								}
							],
							"title": "**P**romoting Solution Discovery",
							"description": "Creating opportunities for self-advocacy and problem resolution is a foundational principle in ethical decision making. Educators should refer students or colleagues to suitable school resources and officials and ensure that these students and colleagues follow up, rather than handle issues themselves. Not only is this in the best interest of those involved, but it also allows situations to be handled objectively and avoids blurring the scope of the educator’s position with that of more expansive roles such as those of counselor, confidant, caregiver, and rescuer. The primary role of the professional educator is most often associated with the tasks of teaching and learning.\n\n**Guiding Questions**\n- What are the inherent professional risks in attempting to fix the immediate or long-term challenges, problems, and obstacles that students, colleagues, or other learning community stakeholders encounter?\n- Am I accepting responsibilities, performing duties, or providing services that correspond with my training and area of certification?\n- How can I help colleagues when their role as a professional educator overlaps with other societal expectations?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-02-risk-mitigation-illustration-v2.png"
								}
							],
							"title": "**R**isk Mitigation",
							"description": "Since educators provide services directly to minors who remain under their care and supervision for extended periods of time without the presence of parents or guardians, the field of education has many professional risks and vulnerabilities. It is important that all educators continually reflect on how to best mitigate risks that may compromise their professional and personal credibility, career goals, personal well-being, and effectiveness as a teacher.\n\n**Guiding Questions**\n- How can a seemingly innocuous and insignificant decision have the potential to put my educational practice at risk?\n- What professional-risk situations inherent in my educational practice do I need to carefully consider (for example, chaperoning an overnight field trip, being approached by a student for personal advice)?\n- What conversations can I have with my colleagues to help identify ways to mitigate risks in situations that we commonly encounter?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-03-objectivity-neutrality-maintained-illustration-v3.png"
								}
							],
							"title": "**O**bjectivity and Neutrality Are Maintained",
							"description": "By maintaining objectivity and neutrality, professional educators should be able to evaluate a situation without emotional entanglements or bias. Remaining objective and neutral mitigates the risks of over-identifying with one party, becoming too focused on the needs of an individual, or advocating for a singular interest instead of advocating for solutions.\n\n**Guiding Questions**\n- When encountering competing tensions (for example, school policy versus what I think is best for a student or colleague; parental influence versus administrative influence), how can I determine the best course of action?\n- How can I remain objective and neutral when I have multiple relationships in the schooling community and as a community member (for example, I’m a friend of one of my student’s parents; I am a youth group leader at a student’s religious center; I coach a student on a club volleyball team during the summer)?\n- How can I best caution a colleague if I suspect the colleague is becoming overwhelmed by the needs of a student?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-04-ensuring-student-welfare-illustration-v2.png"
								}
							],
							"title": "**E**nsuring Student Welfare",
							"description": "Since the individuals receiving services are minors and the educators have been ascribed in loco parentis responsibilities, the primary responsibility of educators is to ensure the students’ safety and welfare. The scope of this charge is not just limited to physical safety, but it also includes emotional, intellectual, psychological, and sexual safety.\n\n**Guiding Questions**\n- Am I doing everything in my power to establish a safe and secure environment for academic, personal, and social growth to occur?\n- Am I willing to safeguard students from duress even if I am not directly responsible for the students?\n- How can I best confront a colleague regarding acts, either committed or omitted, that have the potential to compromise a student’s welfare?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-05-transparency-actions-communications-illustration-v2.png"
								}
							],
							"title": "**T**ransparency in Actions and Communications",
							"description": "Educators must be transparent in their actions and communications. Transparency establishes openness, accountability, trust, credibility, and boundaries. Failure to be sufficiently transparent with appropriate stakeholders (for example, parents, guardians, students, colleagues, administrators) may result in misinterpretation of motives or the appearance of impropriety. Transparency is the best way for educators to ensure that their decisions and behaviors can withstand public scrutiny.\n\n**Guiding Questions**\n- How can I ensure that all communications with students, including digital and electronic communications, are conducted with transparency?\n- How can I balance the need for transparency in my actions and communications with protecting highly confidential information that I am expected to retain (which is considered a “qualified privilege” by the courts)?\n- How do I best approach a colleague about rumors of impropriety that are a result of their lack of transparency in decision making?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-06-boundaries-role-time-place-illustration-v2.png"
								}
							],
							"title": "**H**onoring the Boundaries of Role, Time, and Place",
							"description": "Boundaries encompass the verbal, physical, emotional, and social distances that an educator must maintain to ensure security, structure, and predictability in an educational environment. Most often, the boundaries that are transgressed relate to role, time, and place. By respecting the functions and limits of contracted roles, as well as the working hours and location of the learning environment, secure boundaries are in place for all members of the school community.\n\n**Guiding Questions**\n- In reflecting on my educational practice, which dispositions most risk eroding professional boundaries (for example, assisting with students’ personal challenges, extending academic support beyond school hours, engaging in extracurricular activities, communication with students, parents, and colleagues)?\n- Am I thinking about all my interactions with students (for example, in the school, in the community, and at social functions) as an extension of my professional responsibilities as an educator?\n- How can my colleagues and I openly discuss and agree on boundaries that are most appropriate for our educational context?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-07-integrity-profession-illustration-v2.png"
								}
							],
							"title": "**I**ntegrity of the Profession Is Promoted by the Educator",
							"description": "Educators’ actions reflect on the schooling community, the district, and the profession. An individual educator’s positive actions have the potential to inspire public confidence in the profession. On the other hand, negative actions can cast shadows of doubt and distrust by undermining the effectiveness of a healthy educational structure. The professional educator has an obligation to hold himself or herself responsible for ethical conduct. The educator should take steps when he or she has reason to believe that another educator may be approaching or engaged in an ethically compromising situation.\n\n**Guiding Questions**\n- How often am I reflecting on the daily decisions that I make as a professional educator and how those decisions may affect the integrity of the profession?\n- What steps can I take when I believe that a colleague may be approaching or involved in an ethically compromising situation?\n- How can I best advocate for the profession while also working to reconcile points of disagreement within the school or district?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-08-code-ethics-fidelity-illustration-v2.png"
								}
							],
							"title": "**C**ode of Ethics for Educators Is Maintained with Fidelity",
							"description": "Having an ethics code is a proclamation that a profession is better off when ethical standards are not based solely on individual assessments of what is or is not ethically acceptable but reflect consensus among members on a common purpose. For the education discipline, the *Model Code of Ethics for Educators* (*MCEE*) is a guide for what educators should expect of themselves and one another and should be maintained with fidelity. The *MCEE* assists educators in their efforts to resolve ethical dilemmas and helps educators defend their decisions to schooling-community constituents, institutions, courts, and any other agency that would encourage them to go against the values of the profession. The formal standards are not a substitute for an active, deliberate, and creative approach to fulfilling your ethical responsibilities. They prompt, guide, and inform an educator’s ethical decision-making; they do not serve as a substitute for it.\n\n**Guiding Questions**\n- How can educators from my school or district work together to identify common ethical dilemmas that we encounter?\n- Is there a way to use the *MCEE* as a prompt to discuss resolutions to those ethical dilemmas?\n- Since ethical dilemmas are often situational, contextual, and likely to change over time, how can the *MCEE* continue to guide and inform my decision making as I engage in the practical realities of my work?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-09-stewardship-law-public-trust-illustration-v2.png"
								}
							],
							"title": "**S**tewardship of the Law and Public Trust",
							"description": "Employment policies, licensure statutes, and community laws represent conduct absolutes that have originated from a history of judicial activity. They represent the lowest standard of acceptable behavior deemed necessary to safeguard community members. However, the professional educator is aware that trust in the profession depends on a level of conduct and responsibility that may be higher than what is required by law.\n\n**Guiding Questions**\n- How will relevant procedures, policies, and laws inform my decision making when I encounter ethical dilemmas?\n- It has been said that misconduct is not an event but a process. Will I be able to identify those situations where a series of gradual and unintentional missteps could lead to the transgression of a conduct absolute?\n- What steps can I take when I believe that a colleague may be approaching or involved in actions that may lead to the transgression of a policy, statute, or law?"
						}
					],
					"title": "Ethical Principles"
				}
			},
			"metadata": {
				"type": "SATA",
				"ui_type": "scenario_principle_sata_activity",
				"language": "en-US",
				"position": 5,
				"sourceId": 4050
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "f1a9bdc3-a4c8-458e-9334-30e92d50b3b4",
						"isCorrect": false
					},
					{
						"choiceId": "46204a62-2e25-4afb-b92b-1e949cea02cd",
						"isCorrect": false
					},
					{
						"choiceId": "ec4c313b-1b07-4045-bcf8-2b9b8be5f071",
						"isCorrect": true
					},
					{
						"choiceId": "6460fc2c-579a-484b-8c9a-de756b65bd9c",
						"isCorrect": true
					},
					{
						"choiceId": "56fcee13-f771-45ba-90b6-283c2644c299",
						"isCorrect": false
					},
					{
						"choiceId": "75e64c0a-d917-43a6-9791-3445f95f5b86",
						"isCorrect": false
					},
					{
						"choiceId": "e84d0944-7f48-4338-91cf-23d62857c305",
						"isCorrect": true
					},
					{
						"choiceId": "ecbe7911-f337-4f32-b1bc-ceae6f4068cb",
						"isCorrect": true
					},
					{
						"choiceId": "808b31e0-6b39-4bd6-831d-b8ef69c20786",
						"isCorrect": true
					}
				],
				"selection": {
					"max": 9,
					"min": 1
				}
			},
			"feedback": null,
			"response": {
				"type": "MULTIPLE_SELECT",
				"choices": [
					{
						"id": "f1a9bdc3-a4c8-458e-9334-30e92d50b3b4",
						"text": "Promoting Solution Discovery",
						"numFirstSelections": 0
					},
					{
						"id": "46204a62-2e25-4afb-b92b-1e949cea02cd",
						"text": "Risk Mitigation",
						"numFirstSelections": 0
					},
					{
						"id": "ec4c313b-1b07-4045-bcf8-2b9b8be5f071",
						"text": "Objectivity and Neutrality Are Maintained",
						"numFirstSelections": 0
					},
					{
						"id": "6460fc2c-579a-484b-8c9a-de756b65bd9c",
						"text": "Ensuring Student Welfare",
						"numFirstSelections": 0
					},
					{
						"id": "56fcee13-f771-45ba-90b6-283c2644c299",
						"text": "Transparency in Actions and Communications",
						"numFirstSelections": 0
					},
					{
						"id": "75e64c0a-d917-43a6-9791-3445f95f5b86",
						"text": "Honoring the Boundaries of Role, Time, and Place",
						"numFirstSelections": 0
					},
					{
						"id": "e84d0944-7f48-4338-91cf-23d62857c305",
						"text": "Integrity of the Profession Is Promoted by the Educator",
						"numFirstSelections": 0
					},
					{
						"id": "ecbe7911-f337-4f32-b1bc-ceae6f4068cb",
						"text": "Code of Ethics for Educators Is Maintained with Fidelity",
						"numFirstSelections": 0
					},
					{
						"id": "808b31e0-6b39-4bd6-831d-b8ef69c20786",
						"text": "Stewardship of the Law and Public Trust",
						"numFirstSelections": 0
					}
				],
				"shuffle": false
			},
			"tags": [
				{
					"id": 37090,
					"label": "Module 4: The Professional Educator and the School",
					"title": "Module 4: The Professional Educator and the School",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103688,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of thirteen situations that require you to decide if an educator should “Take action” or “Let it go.” After each situation, you will be presented with two flip cards that describe possible outcomes. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: Take Action or Let It Go",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Good job. Address the failure to disclose required information. Honesty and transparency are essential for hiring decisions. An ethical school culture depends on truthful communication from educators."
							},
							"label": "Take action"
						},
						{
							"id": "B",
							"back": {
								"text": "Try again. Ignoring misrepresentation undermines trust and professional standards."
							},
							"label": "Let it go"
						}
					],
					"count": 13,
					"setup": "Your district’s employment application asks job seekers whether they have ever been convicted of a crime. After applying for and receiving a job in the district, a new teacher shares with you that they failed to disclose a 25-year-old conviction for misdemeanor shoplifting.",
					"title": "Situation 6: Employment Application",
					"number": 6,
					"prompt": "What should you do?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following two flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 13,
				"sourceId": 4130
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37090,
					"label": "Module 4: The Professional Educator and the School",
					"title": "Module 4: The Professional Educator and the School",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103689,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "",
				"items": [
					{
						"media": [
							{
								"type": "IMAGE",
								"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-4/m4_mr_bolden.png"
							}
						],
						"title": "Mr. Bolden",
						"analysis": {
							"text": "Mr. Bolden considers himself a seasoned, authoritative educator whose years of experience justify his approach. His identity is tied to a tough-love philosophy, and he interprets discipline as the primary means for student learning. He is entrenched in long-standing school norms that have gone unchecked, and he believes his methods are validated by tenure, past parent interactions, and perceived tradition. His role in the scenario represents the established culture in a school that may have stopped emphasizing ethical best practices.",
							"title": "Analysis"
						},
						"questions": {
							"text": "The following are reflective questions that he could ask himself.\n- Are my interactions with students aligned with current ethical guidelines and not just my personal beliefs or past habits?\n- Have I mistaken entrenched practices for ethical justification?\n- How might my tone or actions affect students emotionally, socially, or academically?\n- Am I open to feedback from colleagues or am I resisting growth?",
							"title": "Questions"
						},
						"keyTakeaway": {
							"text": "**Professional experience does not replace professional accountability.**\nMr. Bolden’s long tenure and confidence in his tough-love teaching style do not take precedence over his responsibility to meet ethical, regulatory, and relational expectations. His role in the scenario reminds educators that long-standing habits must still be examined against current professional standards and that ignoring feedback can perpetuate harmful norms.",
							"title": "Key Takeaway"
						}
					},
					{
						"media": [
							{
								"type": "IMAGE",
								"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-4/m4_ms_gonzalez.png"
							}
						],
						"title": "Ms. Gonzalez",
						"analysis": {
							"text": "Ms. Gonzalez is navigating a new school culture and balancing her personal values with a responsibility to uphold professional ethics. She feels internal conflict: She wants to assimilate and avoid conflict but is also compelled by the *MCEE* and her own moral compass to protect students and maintain professional integrity. Her role in the scenario represents the ethical disrupter: the professional who identifies inconsistencies between norms and ethical standards.",
							"title": "Analysis"
						},
						"questions": {
							"text": "The following are reflective questions that she could ask herself.\n- Which framework is guiding my concern: my personal values or the regulatory expectations of the profession?\n- What evidence do I have and how can I address this issue objectively?\n- How do I raise concerns respectfully while honoring my responsibilities to colleagues and students?\n- What steps ensure that I avoid retaliation, bias, or assumptions?",
							"title": "Questions"
						},
						"keyTakeaway": {
							"text": "**Ethical instincts matter, even when you are new.**\nMs. Gonzalez demonstrates that maintaining a strong moral compass can alert educators to problems even before they consciously apply policy or procedure. Her willingness to question normalized behavior reflects the importance of trusting one’s values while also turning to regulatory guidance to determine the appropriate course of action.",
							"title": "Key Takeaway"
						}
					},
					{
						"media": [
							{
								"type": "IMAGE",
								"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-4/m4_ms_chen.png"
							}
						],
						"title": "Ms. Chen",
						"analysis": {
							"text": "Ms. Chen is a supportive listener who validates Ms. Gonzalez’ concerns. They talk through ideas and serve as an informal mentor, someone who can help frame the dilemma without being defensive or dismissive. Ms. Chen helps elevate the discussion from frustration to structured ethical reflection.",
							"title": "Analysis"
						},
						"questions": {
							"text": "The following are reflective questions they could ask themself.\n- How can I support colleagues who face ethical tensions without suggesting retaliation or avoidance?\n- Am I modeling respectful, professional discourse about colleagues not present in the discussion?\n- What are my responsibilities when it comes to recognizing and addressing harmful norms?\n- How can I encourage ethical decision making grounded in the *MCEE*?",
							"title": "Questions"
						},
						"keyTakeaway": {
							"text": "**Supportive colleagues help transform concern into ethical action.**\nMs. Chen serves as a reflective partner who validates concerns without encouraging retaliation or bias. Their role in the scenario shows how colleagues can create space for honest reflection, encourage alignment with ethical standards, and model respectful discourse for navigating complex workplace dilemmas.",
							"title": "Key Takeaway"
						}
					}
				],
				"title": "Scenario: Analysis",
				"instruction": "**Directions:** Select each of the following three tabs to review the feedback of Mr. Bolden, Ms. Gonzalez, and Ms. Chen’s involvement in the scenario. Select each of the expandable text buttons within each tab to review the information about each person."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_analysis_cards",
				"language": "en-US",
				"position": 7,
				"sourceId": 4070
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37090,
					"label": "Module 4: The Professional Educator and the School",
					"title": "Module 4: The Professional Educator and the School",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103690,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of thirteen situations that require you to decide if an educator should “Take action” or “Let it go.” After each situation, you will be presented with two flip cards that describe possible outcomes. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: Take Action or Let It Go",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Try again. Listen respectfully to your colleague’s concerns, but do not take any action."
							},
							"label": "Take action"
						},
						{
							"id": "B",
							"back": {
								"text": "Good job. Do not investigate, advocate, or escalate the issue yourself unless officially required. Respecting boundaries protects fairness, due process, and professional relationships."
							},
							"label": "Let it go"
						}
					],
					"count": 13,
					"setup": "You are having lunch with one of your coworkers, Deven, who is considered by his peers to be one of the high school’s best teachers. Deven tells you that two years ago he reported some testing irregularities to his departmental supervisor and, ever since, he has received ratings too low to qualify for merit bonuses.",
					"title": "Situation 4: Rating Retaliation",
					"number": 4,
					"prompt": "What should you do?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following two flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 11,
				"sourceId": 4110
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37090,
					"label": "Module 4: The Professional Educator and the School",
					"title": "Module 4: The Professional Educator and the School",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103691,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of thirteen situations that require you to decide if an educator should “Take action” or “Let it go.” After each situation, you will be presented with two flip cards that describe possible outcomes. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: Take Action or Let It Go",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Good job. Encourage your colleague to provide truthful information. If necessary, report concerns through proper channels. Honesty protects the integrity of the profession and investigative processes."
							},
							"label": "Take action"
						},
						{
							"id": "B",
							"back": {
								"text": "Try again. Allowing false information to remain uncorrected compromises investigations and public trust."
							},
							"label": "Let it go"
						}
					],
					"count": 13,
					"setup": "You are sitting with Emmet, a colleague, in the faculty lounge when he shares with you that he has given false information to an investigator to protect a colleague.",
					"title": "Situation 8: Investigation",
					"number": 8,
					"prompt": "What should you do?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following two flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 15,
				"sourceId": 4150
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37090,
					"label": "Module 4: The Professional Educator and the School",
					"title": "Module 4: The Professional Educator and the School",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103692,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of thirteen situations that require you to decide if an educator should “Take action” or “Let it go.” After each situation, you will be presented with two flip cards that describe possible outcomes. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: Take Action or Let It Go",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Try again. You should only act if credible evidence shows that the situation is affecting students or school operations. If that is the case, discreetly consult a supervisor."
							},
							"label": "Take action"
						},
						{
							"id": "B",
							"back": {
								"text": "Good job. Do not repeat or act on rumors about colleagues’ personal lives. Spreading unverified information can harm individuals and damage school culture."
							},
							"label": "Let it go"
						}
					],
					"count": 13,
					"setup": "At your elementary school, you hear a rumor about the principal having an extramarital affair with the special education teacher.",
					"title": "Situation 5: Rumors",
					"number": 5,
					"prompt": "What should you do?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following two flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 12,
				"sourceId": 4120
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37090,
					"label": "Module 4: The Professional Educator and the School",
					"title": "Module 4: The Professional Educator and the School",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103693,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of thirteen situations that require you to decide if an educator should “Take action” or “Let it go.” After each situation, you will be presented with two flip cards that describe possible outcomes. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: Take Action or Let It Go",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Good job. Report the observation to a school administrator without making assumptions. Let appropriate leaders determine next steps. When student safety is involved, it is better to report concerns than to stay silent."
							},
							"label": "Take action"
						},
						{
							"id": "B",
							"back": {
								"text": "Try again. Ignoring unclear boundary issues can allow harm to go unnoticed."
							},
							"label": "Let it go"
						}
					],
					"count": 13,
					"setup": "At a crowded high school assembly, you observe a teacher and student sitting on the bleachers holding hands in an inconspicuous way.",
					"title": "Situation 7: Ambiguous Behavior",
					"number": 7,
					"prompt": "What should you do?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following two flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 14,
				"sourceId": 4140
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37090,
					"label": "Module 4: The Professional Educator and the School",
					"title": "Module 4: The Professional Educator and the School",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103694,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of thirteen situations that require you to decide if an educator should “Take action” or “Let it go.” After each situation, you will be presented with two flip cards that describe possible outcomes. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: Take Action or Let It Go",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Try again. No action is required. Physical closeness can be appropriate in early childhood settings when transparent and age appropriate."
							},
							"label": "Take action"
						},
						{
							"id": "B",
							"back": {
								"text": "Good job. Recognize the context and setting. Maintain awareness without overreacting. Ethical boundaries depend on age, role, and situation, not on rigid rules."
							},
							"label": "Let it go"
						}
					],
					"count": 13,
					"setup": "As you walk by a prekindergarten classroom, you notice a student sitting on the teacher’s lap during story time.",
					"title": "Situation 11: Story Time",
					"number": 11,
					"prompt": "What should you do?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following two flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 18,
				"sourceId": 4180
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37090,
					"label": "Module 4: The Professional Educator and the School",
					"title": "Module 4: The Professional Educator and the School",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103695,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of thirteen situations that require you to decide if an educator should “Take action” or “Let it go.” After each situation, you will be presented with two flip cards that describe possible outcomes. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: Take Action or Let It Go",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Good job. Privately remind your colleague of reporting requirements and encourage compliance with district policy. Transparency builds trust and protects professional integrity."
							},
							"label": "Take action"
						},
						{
							"id": "B",
							"back": {
								"text": "Try again. Ignoring known policy obligations can harm credibility and careers."
							},
							"label": "Let it go"
						}
					],
					"count": 13,
					"setup": "You are aware that Anna, a fellow teacher, recently pleaded no contest to a theft charge and that she has not reported the incident to the district human resources department as required by district policy.",
					"title": "Situation 12: Crimes Unrelated to Teaching",
					"number": 12,
					"prompt": "What should you do?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following two flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 19,
				"sourceId": 4190
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37090,
					"label": "Module 4: The Professional Educator and the School",
					"title": "Module 4: The Professional Educator and the School",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103696,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"stem": {
					"text": "Several laptop computers were recently stolen from the computer lab at Lincoln High School. A computer science teacher at the school is suspected of having some connection to the theft. The high school principal has asked Mr. Fein, another computer science teacher in the same department, to help with the internal investigation.\n\nWhich of the following is the most appropriate way for Mr. Fein to respond in order to align with the ethical principles for professional educators?"
				},
				"title": "Knowledge Check Question 1"
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "knowledge_check_question",
				"language": "en-US",
				"position": 22,
				"sourceId": 4220
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "9d6977df-3133-45bd-9b2f-84990b0f4683",
						"isCorrect": false
					},
					{
						"choiceId": "f54ef791-be3b-4799-9da3-a6e39148f62e",
						"isCorrect": true
					},
					{
						"choiceId": "60a4322b-82ec-4fe0-8f74-b84d56538cb9",
						"isCorrect": false
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "f54ef791-be3b-4799-9da3-a6e39148f62e",
					"detailed": {
						"text": "A best practice for professional educators is to cooperate fully during ethics investigations and proceedings. Even though cooperating with the investigation may make Mr. Fein uncomfortable or use time that he would rather spend in other ways, these concerns are less important when a situation as serious as theft is involved."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "9d6977df-3133-45bd-9b2f-84990b0f4683",
						"text": "Mr. Fein should decline the principal’s request because participating in the investigation could jeopardize his relationship with a colleague who may be innocent.",
						"numFirstSelections": 0
					},
					{
						"id": "f54ef791-be3b-4799-9da3-a6e39148f62e",
						"text": "Mr. Fein should agree to the principal’s request because participating in the investigation and providing investigators with any information he has is part of his professional responsibility.",
						"numFirstSelections": 0
					},
					{
						"id": "60a4322b-82ec-4fe0-8f74-b84d56538cb9",
						"text": "Mr. Fein should decline the principal’s request because participating in an investigation is not part of his job description and will take time away from teaching activities such as class preparation.",
						"numFirstSelections": 0
					}
				],
				"shuffle": false,
				"instruction": "Choose the best answer from the following options."
			},
			"tags": [
				{
					"id": 37090,
					"label": "Module 4: The Professional Educator and the School",
					"title": "Module 4: The Professional Educator and the School",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103697,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of thirteen situations that require you to decide if an educator should “Take action” or “Let it go.” After each situation, you will be presented with two flip cards that describe possible outcomes. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: Take Action or Let It Go",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Good job. Report your concerns to a supervisor so that attendance patterns can be reviewed appropriately. Ethical professionalism includes accountability and respect for shared responsibilities."
							},
							"label": "Take action"
						},
						{
							"id": "B",
							"back": {
								"text": "Try again. Repeated misuse of leave affects students, colleagues, and fairness in the workplace."
							},
							"label": "Let it go"
						}
					],
					"count": 13,
					"setup": "You overhear Melinda, a fellow teacher, asking for the next day off because she has “nonstop medical tests all day.” She’s been taking a lot of days off recently, and you have had to cover some of her classes. The next morning, during a field trip with your class to a downtown art fair, you notice Melinda and her husband going into a boutique, carrying several shopping bags.",
					"title": "Situation 9: School Leave Policy",
					"number": 9,
					"prompt": "What should you do?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following two flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 16,
				"sourceId": 4160
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37090,
					"label": "Module 4: The Professional Educator and the School",
					"title": "Module 4: The Professional Educator and the School",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103698,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"stem": {
					"text": "A colleague at a school has applied for a health‑related leave of absence that requires submission of medical records to verify a health need. The colleague later discloses that the records are being falsified in order to use the leave time for personal travel.\n\nWhich of the following ethical principles for professional educators is being put at risk?"
				},
				"title": "Knowledge Check Question 2"
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "knowledge_check_question",
				"language": "en-US",
				"position": 23,
				"sourceId": 4230
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "25cd06dd-1c3b-484f-8b4f-ef9739ff701a",
						"isCorrect": false
					},
					{
						"choiceId": "cf40dc8b-2b06-4f48-8994-8397d2e80722",
						"isCorrect": false
					},
					{
						"choiceId": "1059d872-fb21-4f86-b940-a397b0353fea",
						"isCorrect": true
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "1059d872-fb21-4f86-b940-a397b0353fea",
					"detailed": {
						"text": "Misrepresenting one's reasons for an absence or leave and falsifying an official record are both misaligned with the principles of professional ethics. The other two principles are not relevant to this situation."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "25cd06dd-1c3b-484f-8b4f-ef9739ff701a",
						"text": "The duty to engage in respectful discourse with colleagues",
						"numFirstSelections": 0
					},
					{
						"id": "cf40dc8b-2b06-4f48-8994-8397d2e80722",
						"text": "The need to provide students with equality of access to educational resources",
						"numFirstSelections": 0
					},
					{
						"id": "1059d872-fb21-4f86-b940-a397b0353fea",
						"text": "The obligation to engage in honest and appropriate professional conduct",
						"numFirstSelections": 0
					}
				],
				"shuffle": false,
				"instruction": "Choose the best answer from the following options."
			},
			"tags": [
				{
					"id": 37090,
					"label": "Module 4: The Professional Educator and the School",
					"title": "Module 4: The Professional Educator and the School",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103699,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"stem": {
					"text": "A middle school hosts a dance for all students on the Friday before spring break begins. Two teachers, Mr. Pascalides and Mr. Blake, chaperone the event and complain to each other about how long it lasts. After the students have been dismissed, Mr. Pascalides proposes using the school grounds for a personal activity unrelated to their chaperoning responsibilities or any other school purpose.\n\nWhich of the following best explains whether this situation poses a risk to professional principles?"
				},
				"title": "Knowledge Check Question 3"
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "knowledge_check_question",
				"language": "en-US",
				"position": 24,
				"sourceId": 4240
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "65c776ab-393e-4d81-99f0-c6e9d0e28993",
						"isCorrect": true
					},
					{
						"choiceId": "5c444728-cf15-4c01-86e9-99480ccc4e78",
						"isCorrect": false
					},
					{
						"choiceId": "c131fe36-0f36-42dd-8c81-f0807f9f0d22",
						"isCorrect": false
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "65c776ab-393e-4d81-99f0-c6e9d0e28993",
					"detailed": {
						"text": "Educators are responsible for maintaining professional boundaries when they are on school grounds, even after students have left. Because Mr. Pascalides is proposing a personal activity in a school setting unrelated to their professional responsibilities, the situation can blur the boundaries of role, time, and place, and create professional risk."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "65c776ab-393e-4d81-99f0-c6e9d0e28993",
						"text": "Engaging in personal activities on school grounds can blur professional boundaries, even when students are not present, so the situation puts professional principles at risk.",
						"numFirstSelections": 0
					},
					{
						"id": "5c444728-cf15-4c01-86e9-99480ccc4e78",
						"text": "The activity is proposed after the students have been dismissed from the dance, so professional principles are not at risk.",
						"numFirstSelections": 0
					},
					{
						"id": "c131fe36-0f36-42dd-8c81-f0807f9f0d22",
						"text": "The activity does not involve anyone other than the two colleagues and is unlikely to be reported, so professional principles do not apply.",
						"numFirstSelections": 0
					}
				],
				"shuffle": false,
				"instruction": "Choose the best answer from the following options."
			},
			"tags": [
				{
					"id": 37090,
					"label": "Module 4: The Professional Educator and the School",
					"title": "Module 4: The Professional Educator and the School",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103700,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "**Ethical Responsibilities in Navigating School Culture and Professional Dilemmas**\n\nThroughout this scenario, you observed Ms. Gonzalez, a paraeducator new to the school, deal with a difficult tension: the conflict between “how things are done here” and what the *MCEE* outlines as ethical, responsible professional conduct. Her conversation with Ms. Chen highlights a common dilemma for educators: choosing between assimilating into problematic norms or upholding the standards that protect students, colleagues, and the broader profession.\n\nThe module demonstrates that ethical decision making requires a balance between the dispositional framework (that is, our values, beliefs, and professional dispositions) and the regulatory framework (that is, school policies, district guidelines, and the *MCEE*). Ms. Gonzalez’ discomfort with Mr. Bolden’s actions began when his actions were in conflict with her dispositional framework, her belief in dignity, respect, and student welfare, but ultimately required her to apply the regulatory framework to determine the appropriate next steps.\n\n**Ethical Standards Addressed in Module 4**\n\nModule 4 emphasizes that professional educators are entrusted with responsibilities that extend beyond instructional practice. The following *MCEE*-aligned ethical principles were explicitly modeled and applied.\n\n- **Ensuring Student Welfare**\n\nEducators have an overarching duty to safeguard students’ physical, emotional, and psychological well-being.\n\nMs. Gonzalez recognized that ignoring Mr. Bolden’s behavior would endanger students’ welfare and that she must act even though she was not the primary classroom teacher.\n\n- **Objectivity and Neutrality Are Maintained**\n\nProfessional decisions must be grounded in facts and ethical standards, not fear of retaliation, peer pressure, or cultural norms.\n\nMs. Gonzalez resisted the “that’s just how he teaches” narrative and sought to analyze the situation in a clear, unbiased way.\n\n- **Integrity of the Profession Is Promoted by the Educator**\n\nEducators must take steps when they notice a colleague nearing or engaging in ethically compromising situations.\n\nFailing to act allows harmful norms to persist and undermines public trust in educators.\n\n- **Honoring the Boundaries of Role, Time, and Place**\n\nEducators must stay within appropriate professional boundaries and know when a matter requires referral or escalation.\n\nMs. Gonzalez acknowledged that the issues in Mr. Bolden’s classroom exceeded her authority, making documentation and administrative review necessary.\n\n- **Stewardship of the Law and Public Trust**\n\nThe public places tremendous trust in educators to uphold legal and ethical obligations.\n\nBy choosing transparency and documentation, Ms. Gonzalez demonstrated the proactive steps required to maintain that trust.\n\n**Application of the** ***MCEE***\n\nThis scenario serves as a reminder that ethical decision making is active, not passive. As a professional educator, you may encounter situations where school culture, personal discomfort, or fear of conflict complicate your decision making. This module focuses on how to respond thoughtfully and ethically in these situations and provides the following guidance.\n\n- **Recognize the moment when instinct and ethics intersect**\nIf an action or situation is in conflict with your values, this is often an early signal of an ethical issue.\n\n- **Consult the** ***MCEE*** **and school policies to guide next steps**\nThe regulatory framework helps move concerns from feeling based to action based.\n\n- **Document observations objectively**\nClear, evidence-based records support fair and transparent decision making.\n\n- **Use school channels responsibly and professionally**\nEscalation is not retaliation; it is part of ethical stewardship.\n\n- **Rely on trusted colleagues for reflective support**\nAs Ms. Chen modeled, supportive dialogue can turn uncertainty into clarity.",
				"title": "Module 4 Summary"
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "module_summary",
				"language": "en-US",
				"position": 21,
				"sourceId": 4210
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37090,
					"label": "Module 4: The Professional Educator and the School",
					"title": "Module 4: The Professional Educator and the School",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103701,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"stem": {
					"text": "At the end of the football season, Coach Marquis hosts a pool party at his home for the players.\n\nWhich of the following is most important for Coach Marquis to do to maintain transparency?"
				},
				"title": "Knowledge Check Question 4"
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "knowledge_check_question",
				"language": "en-US",
				"position": 25,
				"sourceId": 4250
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "f540b89a-bdda-43bf-97f5-f7826b79fb4e",
						"isCorrect": false
					},
					{
						"choiceId": "2eb49eeb-6695-4c3b-8a72-557dc2d6799e",
						"isCorrect": false
					},
					{
						"choiceId": "3ab18f71-850b-4aa8-8917-ddd61dfdbc6e",
						"isCorrect": true
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "3ab18f71-850b-4aa8-8917-ddd61dfdbc6e",
					"detailed": {
						"text": "Transparency is about acting openly to avoid misunderstandings and to minimize opportunities for wrongdoing. Because this party is associated with a school activity, having other adults present is both a check on the host teacher and a form of protection for him."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "f540b89a-bdda-43bf-97f5-f7826b79fb4e",
						"text": "Put up flyers for the party to let parents, players, and other students know about it.",
						"numFirstSelections": 0
					},
					{
						"id": "2eb49eeb-6695-4c3b-8a72-557dc2d6799e",
						"text": "Talk to the players ahead of time about the importance of being on their best behavior during the party.",
						"numFirstSelections": 0
					},
					{
						"id": "3ab18f71-850b-4aa8-8917-ddd61dfdbc6e",
						"text": "Have the players’ parents or guardians sign permission slips and ensure adult chaperones are in attendance, including at least one other educator or administrator from the school.",
						"numFirstSelections": 0
					}
				],
				"shuffle": false,
				"instruction": "Choose the best answer from the following options."
			},
			"tags": [
				{
					"id": 37090,
					"label": "Module 4: The Professional Educator and the School",
					"title": "Module 4: The Professional Educator and the School",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103702,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of thirteen situations that require you to decide if an educator should “Take action” or “Let it go.” After each situation, you will be presented with two flip cards that describe possible outcomes. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: Take Action or Let It Go",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Good job. Speak privately with your colleague about the missing citations and encourage proper attribution. Educators must model academic honesty for both students and peers."
							},
							"label": "Take action"
						},
						{
							"id": "B",
							"back": {
								"text": "Try again. Ignoring plagiarism weakens professional credibility and ethical standards."
							},
							"label": "Let it go"
						}
					],
					"count": 13,
					"setup": "Tom, a colleague, asks you to review the slides for a presentation that he is about to give at a school faculty meeting. You realize that his presentation slides discuss, in detail and without citation, research findings that you read in a journal two years ago.",
					"title": "Situation 13: Research Findings",
					"number": 13,
					"prompt": "What should you do?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following two flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 20,
				"sourceId": 4200
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37090,
					"label": "Module 4: The Professional Educator and the School",
					"title": "Module 4: The Professional Educator and the School",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103703,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of thirteen situations that require you to decide if an educator should “Take action” or “Let it go.” After each situation, you will be presented with two flip cards that describe possible outcomes. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: Take Action or Let It Go",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Good job. Report the behavior immediately. Possible substance use on school grounds poses a serious safety risk. Student safety always outweighs discomfort or uncertainty."
							},
							"label": "Take action"
						},
						{
							"id": "B",
							"back": {
								"text": "Try again. Ignoring potential criminal or unsafe behavior endangers students and staff."
							},
							"label": "Let it go"
						}
					],
					"count": 13,
					"setup": "You observe Gus, a fellow teacher, go to his car and take an unlabeled packet of powder out of his glove compartment. He sniffs something from it and then returns to the school building.",
					"title": "Situation 10: Substance Abuse",
					"number": 10,
					"prompt": "What should you do?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following two flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 17,
				"sourceId": 4170
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37090,
					"label": "Module 4: The Professional Educator and the School",
					"title": "Module 4: The Professional Educator and the School",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103704,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"stem": {
					"text": "Mr. Toscovich becomes aware that the track coach, Mr. Perkins, gives a student a ride home every night after practice.\n\nWhen deciding whether to take action in response to this information, which of the following is most important for Mr. Toscovich to consider?"
				},
				"title": "Knowledge Check Question 5"
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "knowledge_check_question",
				"language": "en-US",
				"position": 26,
				"sourceId": 4260
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "f972cfe9-3fc7-487b-9866-c821133a19b3",
						"isCorrect": true
					},
					{
						"choiceId": "92ee9427-e798-4d99-8d34-19339ab6af4d",
						"isCorrect": false
					},
					{
						"choiceId": "2a6d1d7b-0380-4a69-9f4a-c4cadd1043b1",
						"isCorrect": false
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "f972cfe9-3fc7-487b-9866-c821133a19b3",
					"detailed": {
						"text": "It is important for educators to act when they see a serious potential for impropriety in their colleague’s actions. By taking action in this situation, Mr. Toscovich could protect the student, the reputation of his colleague, the reputation of the school, and the professional standing of educators in general."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "f972cfe9-3fc7-487b-9866-c821133a19b3",
						"text": "Educators should intervene when they witness potentially inappropriate or risky conduct.",
						"numFirstSelections": 0
					},
					{
						"id": "92ee9427-e798-4d99-8d34-19339ab6af4d",
						"text": "Educators should be given the benefit of the doubt when they are trying to help students.",
						"numFirstSelections": 0
					},
					{
						"id": "2a6d1d7b-0380-4a69-9f4a-c4cadd1043b1",
						"text": "Mr. Toscovich’s familiarity with the track coach’s character should determine how he handles the situation.",
						"numFirstSelections": 0
					}
				],
				"shuffle": false,
				"instruction": "Choose the best answer from the following options."
			},
			"tags": [
				{
					"id": 37090,
					"label": "Module 4: The Professional Educator and the School",
					"title": "Module 4: The Professional Educator and the School",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		}
	],
	"examName": "Module 4: The Professional Educator and the School",
	"sessionSubType": "PRACTICE_TEST",
	"publicId": "f192a0f0-aaaf-489d-806f-6f2155db92b8",
	"sessionType": "SUMMATIVE",
	"totalTime": null
}
